import { SyntheticEvent } from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { grey } from '@mui/material/colors';

import { all, autocompleteOpenTextLabel } from '../../const/commonConst';
import { SearchCriteriaType } from '../../type/SearchCriteriaType';
import { search } from '../../../currentCarPlace/const/currentCarPlacePageSize';

type SearchAutocompletePropsType = {
	id: string;
	options: SearchCriteriaType[];
	label: string;
	value: SearchCriteriaType;
	onChange: (event: SyntheticEvent<Element, Event>, value: SearchCriteriaType | null) => void;
};

type SearchStyledAutocompletePropsType = {
	label: string;
};

/**
 * 検索条件選択フィールド
 */
export const SearchAutocomplete = (props: SearchAutocompletePropsType) => {
	const { id, options, label, value, onChange } = props;

	return (
		<Autocomplete
			id={id}
			size="small"
			disableClearable
			value={value}
			options={options}
			isOptionEqualToValue={(option, value) => option.id === value.id}
			renderInput={(params) => <TextField {...params} label={label} />}
			onChange={onChange}
			openText={`${label}${autocompleteOpenTextLabel}`}
			sx={{ width: search.width }}
		/>
	);
};

/**
 * 検索条件選択フィールド(グレーアウト表示)
 */
export const SearchStyledAutocomplete = (props: SearchStyledAutocompletePropsType) => {
	return (
		<Autocomplete
			size="small"
			disabled
			options={[all]}
			renderInput={(params) => <TextField {...params} label={props.label} />}
			openText={`${props.label}${autocompleteOpenTextLabel}`}
			sx={{ width: search.width, backgroundColor: grey[400], borderRadius: '4px' }}
		/>
	);
};
